<template>
  <el-card v-show="visible">
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4" v-for="(record, index) in tableData" :key="index">
          <div class="card">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-9">
                  <div class="numbers">
                    <p class="text-sm mb-0 text-uppercase font-weight-bold">
                      <el-form label-position="top">
                        <el-form-item :label="$t('usar-cartao')">
                          <el-radio v-model="record.selected" key="1" label="1">Prévia <el-tag type="warning">{{ record.cardpost.audit }}</el-tag></el-radio>
                          <el-radio v-model="record.selected" key="2" label="2">Postagem <el-tag>{{ record.cardpost.prepost }}</el-tag></el-radio>
                          <el-radio v-model="record.selected" key="3" label="3">OUTRO</el-radio>
                          <el-input v-model="record.another" size="mini" v-if="record.selected === '3'"  autocomplete="off"></el-input>
                        </el-form-item>
                      </el-form>
                    </p>
                  </div>
                </div>
                <div class="col-3 text-end">
                  <div class="icon icon-shape bg-gradient-orange shadow-primary text-center rounded-circle right white">
                    {{ record.total }}
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom clearfix">
              <el-button type="success" plain class="w-100" @click="apply(index)">{{
                $t("aplicar")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import AuditPendenciesOptions from './AuditPendenciesOptions';

export default {
  name: "AuditPendenciesCardPostDiff",
  components: {
    AuditPendenciesOptions ,
  },
  data() {
    return {
      visible: false,
      tableData: [],
      cardpost: '',
      another: '',
      action: '',
    }
  },  
  methods: {
    show(action) {
      this.visible = true;
      this.action = action;
      this.fetchRecords();
    },
    hide() {
      this.visible = false;
    },
    apply(index) {
      const vm = this;
      const record = vm.tableData[index];
      if (record.selected === '3' && !record.another) {
        return vm.$message({ type: "error", message: 'É preciso informar o cartão de postagem!' });
      }
      const loading = vm.$loading(vm.$options.loading);
      AuditService.change(record.selected, record.another, record.cardpost.audit, record.cardpost.prepost)
        .then((response) => {
          vm.$message({ type: "success", message: 'Cartão de postagem setado nas pendências de auditoria!' });
          vm.$emit('reload');
          vm.visible = false;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.tableData = [];
      const loading = vm.$loading(vm.$options.loading);
      AuditService.diff()
        .then((response) => {
          vm.tableData = response;
          for (let i=0; i < vm.tableData.length; i++) {
            vm.tableData[i].selected = vm.action;
          }
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
  },
};
</script>
<style scoped>
.list-group-item {
  padding-top: 15px !important;
}
</style>